import { latestArticles } from '@/mocks/articles';
import ArticleCard from '@/components/base/ArticleCard';
import { Link } from 'react-router-dom';

export default function LatestArticles() {
  const articles = latestArticles.slice(0, 9);

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-3 whitespace-nowrap">
              最新发布
            </span>
            <h2
              className="text-2xl md:text-3xl font-bold text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              最新资讯
            </h2>
          </div>
          <Link
            to="/category/local-life"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
          >
            浏览更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/local-life"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            加载更多资讯 <i className="ri-arrow-down-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}